module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Attachment1-ee726295cf58a4f96a3ffa872476d681.svg";